import styled from "styled-components";

export const RequirementContentWrap = styled.div`
  margin: 20px 0;
  margin-bottom: 40px;
`

export const ReviewDescTip = styled.span`
  font-weight: 500;
`

export const ReviewDesc = styled.span`
  font-size: 14;
  color: grey;
`